"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Message_1 = require("@idp/ui-components/components/atoms/Message");
var MessageProps_1 = require("@idp/ui-components/components/atoms/Message/MessageProps");
/** Stylesheets */
var styles = require("./PageLevelError.scss");
var PageLevelError = /** @class */ (function (_super) {
    __extends(PageLevelError, _super);
    function PageLevelError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageLevelError.prototype.render = function () {
        return (React.createElement("div", { className: [styles.alert, this.props.options.className].join(' '), "data-test-id": this.props.testId },
            React.createElement(Message_1.default, { data: { type: MessageProps_1.MessageType.ERROR }, options: { closeButton: false } },
                React.createElement("div", { className: [styles.alertContent].join(' '), dangerouslySetInnerHTML: {
                        __html: this.props.data.errorMessageText,
                    } }))));
    };
    return PageLevelError;
}(React.Component));
exports.default = PageLevelError;
//# sourceMappingURL=PageLevelError.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelError/PageLevelError.js
// module id = 353
// module chunks = 8